import definitionRoutes from './definitions';
import groupRoutes from './groups';
import licenceRoutes from './licences';

export default [
  ...definitionRoutes,
  ...groupRoutes,
  ...licenceRoutes,
];
